<template>
  <div
    v-if="!closed"
    id="beta-bar"
  >
    <div class="container">
      <el-row
        type="flex"
        align="middle"
      >
        <el-col
          :md="24"
          :lg="2"
        >
          <span class="beta mr-3">BETA</span>
        </el-col>
        <el-col
          :md="24"
          :lg="14"
        >
          <p>
            This is a new service - your
            <a
              :href="getContactUsUrl"
              target="_blank"
              class="feedback-link"
            >feedback</a>
            will help us improve it
          </p>
        </el-col>
        <el-col
          :md="24"
          :lg="8"
          class="d-flex"
        >
          <div class="right-wrap">
            <p>
              Need help?<a
                class="ml-1 mr-2"
                aria-label="Click to create a support ticket"
                :href="getContactUsUrl"
                target="_blank"
              >Get in touch</a>
            </p>
            <button
              class="btn-close"
              tabindex="0"
              @click="closeBetaBar($event)"
              @keyup.enter="closeBetaBar($event)"
            >
              <span class="sr-only">Close beta notice</span>
              <svg-white-close />
            </button>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import cookieMixin from '@/mixins/cookie-mixin'
import svgWhiteClose from '@/components/assets/svg-white-close'

export default {
  components: {
    svgWhiteClose
  },
  mixins: [cookieMixin],
  data() {
    return {
      closed: true
    };
  },
  computed: {
    getContactUsUrl(){
      return`${process.env.VUE_APP_BE_WELL_CMS_URL}/for-my-organisation/contact-us-cwb`
    }
  },
  mounted() {
    this.closed = this.getCookie('beta-bar-closed')
  },
  methods: {
    closeBetaBar () {
      this.setCookie('beta-bar-closed', true, 365 * 100);
      this.closed = true
    }
  },
};
</script>

<style lang="scss" scoped>
a {
  color: $link-blue;
  &:hover {
    text-decoration: underline;
    color: $black;
  }
}

#beta-bar {
  position: relaitve;
  background: $white;
  border-bottom: 1px solid #d9d9d9;
  z-index: 30;
  padding: 10px 0;

  .el-row {
    @media (max-width: 1081px) {
      display: block;
    }
  }

  .beta {
    background-color: $link-blue;
    color: $white;
    text-align: center;
    width: 80px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: "Co Headline Bold", sans-serif;
    font-size: 20px;
    @media (max-width: 1081px) {
      margin-bottom: 8px;
      display: block;
    }
  }

  p {
    @media (max-width: 1339px) {
      margin-top: 2px;
    }
    @media (max-width: 1081px) {
      margin-bottom: 6px;
    }
  }
}

.right-wrap {
  display: flex;
  justify-content: center;
  margin-left: auto;
}

.btn-close {
  display: block;
  cursor: pointer;
  background: transparent;
  &:focus {
    svg {
    outline: -webkit-focus-ring-color auto 5px;
  }
  }
}

p:first-child {
  @media (max-width: 1339px) {
    margin-left: 10px;
  }
  @media (max-width: 1081px) {
    margin-left: 0px;
  }
}
</style>
